import axios from '@/libs/api.request'

// 登录
export const apiLogin = (data) => {
    return axios.request({
        url: '/auth/login',
        method: 'post',
        data
    })
}

// 退出
export const apiLogout = (data) => {
    return axios.request({
        url: '/auth/logout',
        method: 'get',
        data
    })
}
